// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__g_VwP","inputDescription":"styles_inputDescription__2GU0a"};